var _defs, _polyline, _line, _line2, _polyline2, _line3, _line4, _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _polygon3, _polygon4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _polygon5, _polygon6, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _polygon7, _polygon8, _polygon9, _polygon10, _rect49, _rect50, _polygon11, _polygon12, _polygon13, _polygon14, _rect51, _rect52, _rect53, _rect54, _polygon15, _polygon16, _polygon17, _polygon18, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _polygon19, _polygon20, _rect65, _rect66, _polygon21, _polygon22, _rect67, _rect68, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polyline3, _rect69, _rect70, _rect71, _rect72, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _rect73, _rect74, _rect75, _rect76, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _rect77, _path, _polygon29, _polygon30, _rect78, _rect79, _rect80, _rect81, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _rect82, _path2, _rect83, _path3, _path4, _text33, _text34, _rect84, _path5, _polygon31, _polygon32, _rect85, _rect86, _rect87, _rect88, _path6, _rect89, _rect90, _rect91, _rect92, _path7, _polygon33, _text35, _text36, _rect93, _path8, _polygon34, _rect94, _rect95, _rect96, _rect97, _path9, _text37, _text38, _rect98, _path10, _path11, _path12, _path13, _rect99, _path14, _path15, _polygon35, _polygon36, _polygon37, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Phone_mockup",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 739.84 505.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-8 {\n        fill: #9e9f9f;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 7.06 7.06;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-7 {\n        stroke: #9e9f9f;\n      }\n\n      .cls-2, .cls-4, .cls-5, .cls-7 {\n        stroke-width: 1.17px;\n      }\n\n      .cls-9 {\n        fill: #a69664;\n      }\n\n      .cls-10 {\n        fill: #b4a786;\n      }\n\n      .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16 {\n        font-family: NotoSansCJKtc-Black-B5pc-H, 'Noto Sans CJK TC';\n        font-weight: 800;\n      }\n\n      .cls-11, .cls-12, .cls-17, .cls-16 {\n        fill: #3d3a39;\n      }\n\n      .cls-11, .cls-13, .cls-17, .cls-18 {\n        font-size: 6.54px;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-width: .58px;\n      }\n\n      .cls-19 {\n        fill: #b5cddb;\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-5, .cls-6 {\n        stroke: #fff;\n      }\n\n      .cls-21, .cls-13, .cls-14, .cls-15, .cls-18 {\n        fill: #fff;\n      }\n\n      .cls-22 {\n        fill: #595757;\n        font-size: 8.62px;\n      }\n\n      .cls-22, .cls-23 {\n        font-family: NotoSansCJKtc-Regular-B5pc-H, 'Noto Sans CJK TC';\n      }\n\n      .cls-7 {\n        stroke-dasharray: 6.76 6.76;\n      }\n\n      .cls-24 {\n        fill: #b0aeae;\n      }\n\n      .cls-12, .cls-14 {\n        font-size: 2.95px;\n      }\n\n      .cls-25 {\n        fill: #84939d;\n      }\n\n      .cls-23 {\n        font-size: 10.37px;\n      }\n\n      .cls-17, .cls-18 {\n        font-family: NotoSansCJKtc-Medium-B5pc-H, 'Noto Sans CJK TC';\n        font-weight: 500;\n      }\n\n      .cls-26 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-27 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-28 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-15, .cls-16 {\n        font-size: 4.91px;\n      }\n\n      .cls-29 {\n        fill: #459ada;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 739.84,
    height: 505.61
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "612.89 265.31 732.82 145.53 611.38 85.31"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 612.89,
    y1: 265.31,
    x2: 615.37,
    y2: 262.83
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 620.37,
    y1: 257.84,
    x2: 727.84,
    y2: 150.5
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "730.34 148.01 732.82 145.53 729.68 143.97"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 723.61,
    y1: 140.96,
    x2: 617.56,
    y2: 88.37
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 614.53,
    y1: 86.87,
    x2: 611.38,
    y2: 85.31
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 93.78,
    y: 149.69,
    width: 32.28,
    height: 132.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 93.78,
    y: 149.69,
    width: 32.28,
    height: 132.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 7.02,
    y: 7.02,
    width: 272.66,
    height: 125.71
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 7.02,
    y: 7.02,
    width: 272.66,
    height: 125.71
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "547.58 266.12 530.95 270.86 511.96 251.88 485.29 278.55 522.3 315.57 486.52 351.35 506.49 371.31 580.95 296.85 547.58 266.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "547.58 266.12 530.95 270.86 511.96 251.88 485.29 278.55 522.3 315.57 486.52 351.35 506.49 371.31 580.95 296.85 547.58 266.12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "472.78 43.13 494.79 43.13 501.97 31.06 453.48 7.02 418.42 7.02 418.42 83.08 397.73 83.08 397.73 83.35 397.73 90.32 397.73 130.83 472.78 130.83 495.4 130.83 495.4 90.32 472.78 90.32 472.78 83.35 472.78 43.13"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "472.78 43.13 494.79 43.13 501.97 31.06 453.48 7.02 418.42 7.02 418.42 83.08 397.73 83.08 397.73 83.35 397.73 90.32 397.73 130.83 472.78 130.83 495.4 130.83 495.4 90.32 472.78 90.32 472.78 83.35 472.78 43.13"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 60.93,
    y: 100.96,
    width: 127.52,
    height: 31.77
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 60.93,
    y: 100.96,
    width: 127.52,
    height: 31.77
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 7.02,
    y: 7.26,
    width: 38.97,
    height: 125.47
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7.02,
    y: 7.26,
    width: 38.97,
    height: 125.47
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 7.02,
    y: 156.16,
    width: 59.78,
    height: 110.09
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7.02,
    y: 156.16,
    width: 59.78,
    height: 110.09
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "227.53 281.79 211.66 281.79 211.66 199.72 273.9 199.72 289.98 216.26 227.53 281.79"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "227.53 281.79 211.66 281.79 211.66 199.72 273.9 199.72 289.98 216.26 227.53 281.79"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 202.76,
    y: 112.33,
    width: 76.91,
    height: 20.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 202.76,
    y: 112.33,
    width: 76.91,
    height: 20.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 314.82,
    y: 112.33,
    width: 49.52,
    height: 20.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.82,
    y: 112.33,
    width: 49.52,
    height: 20.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 314.82,
    y: 85.94,
    width: 18.59,
    height: 18.95
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.82,
    y: 85.94,
    width: 18.59,
    height: 18.95
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 314.82,
    y: 63.24,
    width: 18.59,
    height: 18.95
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.82,
    y: 63.24,
    width: 18.59,
    height: 18.95
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 314.82,
    y: 40.38,
    width: 18.59,
    height: 18.95
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.82,
    y: 40.38,
    width: 18.59,
    height: 18.95
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 314.82,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 314.82,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 335.41,
    y: 7.95,
    width: 7.83,
    height: 102.37
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 335.41,
    y: 7.95,
    width: 7.83,
    height: 102.37
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 345.4,
    y: 63.24,
    width: 18.59,
    height: 18.95
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 345.4,
    y: 63.24,
    width: 18.59,
    height: 18.95
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 345.4,
    y: 40.38,
    width: 18.59,
    height: 18.95
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 345.4,
    y: 40.38,
    width: 18.59,
    height: 18.95
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 345.4,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 345.4,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 397.53,
    y: 61.76,
    width: 18.59,
    height: 18.95
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 397.53,
    y: 61.76,
    width: 18.59,
    height: 18.95
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 397.53,
    y: 39.6,
    width: 18.59,
    height: 18.95
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 397.53,
    y: 39.6,
    width: 18.59,
    height: 18.95
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 474.57,
    y: 69.97,
    width: 18.59,
    height: 17.01
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.57,
    y: 69.97,
    width: 18.59,
    height: 17.01
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 474.57,
    y: 50.75,
    width: 18.59,
    height: 16.86
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 474.57,
    y: 50.75,
    width: 18.59,
    height: 16.86
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 397.53,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 397.53,
    y: 17.45,
    width: 18.59,
    height: 18.95
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 397.73,
    y: 107.26,
    width: 97.67,
    height: 23.57
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 397.73,
    y: 107.26,
    width: 97.67,
    height: 23.57
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 158.23,
    y: 242.59,
    width: 40.73,
    height: 39.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 158.23,
    y: 242.59,
    width: 40.73,
    height: 39.2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 158.23,
    y: 187.94,
    width: 40.73,
    height: 54.66
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 158.23,
    y: 187.94,
    width: 40.73,
    height: 54.66
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 158.23,
    y: 149.69,
    width: 40.73,
    height: 38.24
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 158.23,
    y: 149.69,
    width: 40.73,
    height: 38.24
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "303.84 149.69 246.65 149.69 246.65 187.69 272.86 187.69 311.36 157.1 303.84 149.69"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.84 149.69 246.65 149.69 246.65 187.69 272.86 187.69 311.36 157.1 303.84 149.69"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "331.7 176.34 311.36 157.1 272.86 187.69 279.3 188.47 299.34 208.3 331.7 176.34"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "331.7 176.34 311.36 157.1 272.86 187.69 279.3 188.47 299.34 208.3 331.7 176.34"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 211.66,
    y: 149.69,
    width: 35.22,
    height: 38
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 211.66,
    y: 149.69,
    width: 35.22,
    height: 38
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "522.95 41.54 510.84 67.67 510.84 130.83 594.8 130.83 594.8 140.12 611.38 140.12 611.38 130.83 611.38 85.31 522.95 41.54"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "522.95 41.54 510.84 67.67 510.84 130.83 594.8 130.83 594.8 140.12 611.38 140.12 611.38 130.83 611.38 85.31 522.95 41.54"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "276.73 308.44 247.87 345.78 247.87 366.35 318.12 436.93 356.95 401.12 356.95 385.65 276.73 308.44"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.73 308.44 247.87 345.78 247.87 366.35 318.12 436.93 356.95 401.12 356.95 385.65 276.73 308.44"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 7.02,
    y: 308.44,
    width: 74.57,
    height: 57.68
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7.02,
    y: 308.44,
    width: 74.57,
    height: 57.68
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 81.58,
    y: 308.44,
    width: 85.24,
    height: 57.68
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.58,
    y: 308.44,
    width: 85.24,
    height: 57.68
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "276.73 308.44 166.83 308.44 166.83 366.12 247.64 366.12 247.87 366.35 247.87 345.78 276.73 308.44"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.73 308.44 166.83 308.44 166.83 366.12 247.64 366.12 247.87 366.35 247.87 345.78 276.73 308.44"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "522.3 315.56 485.29 278.55 477.97 285.87 478.3 312.05 404.76 385.59 404.89 400.06 441.31 436.48 506.49 371.31 486.52 351.35 522.3 315.56"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "522.3 315.56 485.29 278.55 477.97 285.87 478.3 312.05 404.76 385.59 404.89 400.06 441.31 436.48 506.49 371.31 486.52 351.35 522.3 315.56"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 286.29,
    y: 243.01,
    width: 50.95,
    height: 50.52,
    transform: "translate(-98.39 299.03) rotate(-45)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 286.29,
    y: 243.01,
    width: 50.95,
    height: 50.52,
    transform: "translate(-98.39 299.03) rotate(-45)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 358.15,
    y: 315.52,
    width: 50.95,
    height: 49.21,
    transform: "translate(-128.15 370.88) rotate(-45)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 358.15,
    y: 315.52,
    width: 50.95,
    height: 49.21,
    transform: "translate(-128.15 370.88) rotate(-45)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 322.45,
    y: 278.56,
    width: 50.95,
    height: 51.75,
    transform: "translate(-113.36 335.19) rotate(-45)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 322.45,
    y: 278.56,
    width: 50.95,
    height: 51.75,
    transform: "translate(-113.36 335.19) rotate(-45)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 332.78,
    y: 200.32,
    width: 43.38,
    height: 50.52,
    transform: "translate(-55.69 316.71) rotate(-45)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 332.78,
    y: 200.32,
    width: 43.38,
    height: 50.52,
    transform: "translate(-55.69 316.71) rotate(-45)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 368.93,
    y: 235.86,
    width: 43.38,
    height: 51.75,
    transform: "translate(-70.67 352.87) rotate(-45)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 368.93,
    y: 235.86,
    width: 43.38,
    height: 51.75,
    transform: "translate(-70.67 352.87) rotate(-45)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "424.25 264.7 393.58 295.37 428.38 330.17 450.76 307.79 450.81 291.25 424.25 264.7"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "424.25 264.7 393.58 295.37 428.38 330.17 450.76 307.79 450.81 291.25 424.25 264.7"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 419.9,
    y: 183.97,
    width: 57.53,
    height: 36.68,
    transform: "translate(-11.64 376.51) rotate(-45)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 419.9,
    y: 183.97,
    width: 57.53,
    height: 36.68,
    transform: "translate(-11.64 376.51) rotate(-45)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "440.99 153.96 394.74 154.17 377.3 171.62 415.35 209.68 456.03 169 440.99 153.96"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "440.99 153.96 394.74 154.17 377.3 171.62 415.35 209.68 456.03 169 440.99 153.96"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 446.48,
    y: 209.64,
    width: 57.53,
    height: 38.5,
    transform: "translate(-22.65 403.09) rotate(-45)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 446.48,
    y: 209.64,
    width: 57.53,
    height: 38.5,
    transform: "translate(-22.65 403.09) rotate(-45)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "522.57 153.45 457.27 152.79 501.12 196.64 522.57 175.19 522.57 153.45"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "522.57 153.45 457.27 152.79 501.12 196.64 522.57 175.19 522.57 153.45"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "522.57 153.45 522.57 175.19 501.12 196.64 517.92 213.44 569.61 161.75 569.98 153.93 522.57 153.45"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "522.57 153.45 522.57 175.19 501.12 196.64 517.92 213.44 569.61 161.75 569.98 153.93 522.57 153.45"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "611.25 192.36 594.58 192.36 594.61 201.36 562.13 201.72 511.97 251.88 530.95 270.86 547.58 266.12 580.95 296.85 611.25 266.55 611.25 192.36"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "611.25 192.36 594.58 192.36 594.61 201.36 562.13 201.72 511.97 251.88 530.95 270.86 547.58 266.12 580.95 296.85 611.25 266.55 611.25 192.36"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "611.38 85.31 453.48 7.02 247.73 7.02 7.02 7.02 7.02 366.39 247.73 366.39 379.31 498.59 612.89 265.31"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 129.29,
    y: 172.68,
    width: 11.63,
    height: 87.37
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 129.29,
    y: 172.68,
    width: 11.63,
    height: 87.37
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 143.46,
    y: 172.68,
    width: 11.63,
    height: 87.37
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 143.46,
    y: 172.68,
    width: 11.63,
    height: 87.37
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 178.56,
    x2: 155.19,
    y2: 178.56
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 184.38,
    x2: 155.19,
    y2: 184.38
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 190.21,
    x2: 155.19,
    y2: 190.21
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 196.03,
    x2: 155.19,
    y2: 196.03
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 201.86,
    x2: 155.19,
    y2: 201.86
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 207.68,
    x2: 155.19,
    y2: 207.68
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 213.51,
    x2: 155.19,
    y2: 213.51
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 219.33,
    x2: 155.19,
    y2: 219.33
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 225.16,
    x2: 155.19,
    y2: 225.16
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 230.98,
    x2: 155.19,
    y2: 230.98
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 236.81,
    x2: 155.19,
    y2: 236.81
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 242.63,
    x2: 155.19,
    y2: 242.63
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 248.46,
    x2: 155.19,
    y2: 248.46
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.19,
    y1: 254.28,
    x2: 155.19,
    y2: 254.28
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 403,
    y: 191.87,
    width: 11.63,
    height: 87.37,
    transform: "translate(-46.83 358.07) rotate(-45)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 403,
    y: 191.87,
    width: 11.63,
    height: 87.37,
    transform: "translate(-46.83 358.07) rotate(-45)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 413.02,
    y: 181.85,
    width: 11.63,
    height: 87.37,
    transform: "translate(-36.81 362.22) rotate(-45)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 413.02,
    y: 181.85,
    width: 11.63,
    height: 87.37,
    transform: "translate(-36.81 362.22) rotate(-45)"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 377.9,
    y1: 213.01,
    x2: 396.28,
    y2: 194.63
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 382.02,
    y1: 217.13,
    x2: 400.4,
    y2: 198.75
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 386.14,
    y1: 221.25,
    x2: 404.52,
    y2: 202.87
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 390.26,
    y1: 225.36,
    x2: 408.64,
    y2: 206.99
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 394.38,
    y1: 229.48,
    x2: 412.76,
    y2: 211.1
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 398.49,
    y1: 233.6,
    x2: 416.87,
    y2: 215.22
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 402.61,
    y1: 237.72,
    x2: 420.99,
    y2: 219.34
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 406.73,
    y1: 241.84,
    x2: 425.11,
    y2: 223.46
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 410.85,
    y1: 245.96,
    x2: 429.23,
    y2: 227.58
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 414.97,
    y1: 250.08,
    x2: 433.35,
    y2: 231.7
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 419.09,
    y1: 254.2,
    x2: 437.47,
    y2: 235.82
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 423.21,
    y1: 258.32,
    x2: 441.59,
    y2: 239.94
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 427.33,
    y1: 262.43,
    x2: 445.71,
    y2: 244.05
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 431.45,
    y1: 266.55,
    x2: 449.83,
    y2: 248.17
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 375.8,
    y: 58.14,
    width: 16.31,
    height: 16.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M392.4,74.74h-16.89v-16.89h16.89v16.89ZM376.1,74.15h15.72v-15.72h-15.72v15.72Z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "381.65 59.78 379.69 61.73 380.61 61.73 381.65 60.7 382.7 61.73 383.62 61.73 381.65 59.78"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "387.3 59.78 386.26 60.82 385.22 59.78 384.3 59.78 386.26 61.74 388.22 59.78 387.3 59.78"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 380.43,
    y: 66.66,
    width: 0.59,
    height: 2.77
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 381.01,
    y: 69.43,
    width: 0.59,
    height: 2.77
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 382.78,
    y: 66.66,
    width: 0.59,
    height: 2.77
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 382.2,
    y: 69.43,
    width: 0.59,
    height: 2.77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M381.9,66.33c-.64,0-1.17-.52-1.17-1.17s.52-1.17,1.17-1.17,1.17.52,1.17,1.17-.52,1.17-1.17,1.17M381.9,64.58c-.32,0-.58.26-.58.58s.26.58.58.58.58-.26.58-.58-.26-.58-.58-.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 384.53,
    y: 66.66,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 385.12,
    y: 69.43,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 386.88,
    y: 66.66,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 386.3,
    y: 69.43,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M386.01,66.33c-.64,0-1.17-.52-1.17-1.17s.52-1.17,1.17-1.17,1.17.52,1.17,1.17-.52,1.17-1.17,1.17M386.01,64.58c-.32,0-.58.26-.58.58s.26.58.58.58.58-.26.58-.58-.26-.58-.58-.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "389.16 72.81 378.77 72.81 378.77 62.39 389.15 62.39 389.15 71.48 388.5 71.48 388.5 63.04 379.42 63.04 379.42 72.16 389.16 72.16 389.16 72.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 295.93,
    y: 53.53,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M312.53,70.13h-16.89v-16.89h16.89v16.89ZM296.22,69.55h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "301.78 55.18 299.81 57.13 300.74 57.13 301.78 56.09 302.82 57.13 303.74 57.13 301.78 55.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "307.42 55.18 306.38 56.22 305.34 55.18 304.42 55.18 306.38 57.13 308.34 55.18 307.42 55.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 300.55,
    y: 62.05,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 301.13,
    y: 64.83,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 302.9,
    y: 62.05,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 302.32,
    y: 64.83,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M302.03,61.72c-.64,0-1.17-.52-1.17-1.17s.52-1.17,1.17-1.17,1.17.52,1.17,1.17-.52,1.17-1.17,1.17M302.03,59.98c-.32,0-.58.26-.58.58s.26.58.58.58.58-.26.58-.58-.26-.58-.58-.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 304.66,
    y: 62.05,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 305.24,
    y: 64.83,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 307.01,
    y: 62.05,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 306.42,
    y: 64.83,
    width: 0.59,
    height: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M306.13,61.72c-.64,0-1.17-.52-1.17-1.17s.52-1.17,1.17-1.17,1.17.52,1.17,1.17-.52,1.17-1.17,1.17M306.13,59.98c-.32,0-.58.26-.58.58s.26.58.58.58.58-.26.58-.58-.26-.58-.58-.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "309.28 68.2 298.89 68.2 298.89 57.78 309.27 57.78 309.27 66.88 308.62 66.88 308.62 58.43 299.54 58.43 299.54 67.55 309.28 67.55 309.28 68.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.64,
    y: 201.48,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M153.24,218.08h-16.89v-16.89h16.89v16.89ZM136.93,217.49h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "143.16 216.15 138.28 216.15 138.28 212.89 141.98 212.89 147.4 208.99 151.3 208.99 151.3 210.93 150.66 210.93 150.66 209.64 147.61 209.64 142.19 213.54 138.93 213.54 138.93 215.5 142.95 215.5 148.33 211.6 151.29 211.6 151.29 212.25 148.54 212.25 143.16 216.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 142.19,
    y: 210.28,
    width: 0.65,
    height: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 143.49,
    y: 210.28,
    width: 0.65,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 141.55,
    y: 206.38,
    width: 0.65,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 144.14,
    y: 206.38,
    width: 0.65,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M143.17,206c-.79,0-1.43-.64-1.43-1.43s.64-1.43,1.43-1.43,1.43.64,1.43,1.43-.64,1.43-1.43,1.43M143.17,203.78c-.43,0-.78.35-.78.78s.35.78.78.78.78-.35.78-.78-.35-.78-.78-.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 408.56,
    y: 217.23,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M425.16,233.83h-16.89v-16.89h16.89v16.89ZM408.85,233.25h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "415.08 231.9 410.2 231.9 410.2 228.64 413.9 228.64 419.32 224.74 423.23 224.74 423.23 226.69 422.58 226.69 422.58 225.39 419.53 225.39 414.11 229.29 410.85 229.29 410.85 231.25 414.87 231.25 420.26 227.35 423.22 227.35 423.22 228 420.47 228 415.08 231.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 414.11,
    y: 226.03,
    width: 0.65,
    height: 2.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 415.41,
    y: 226.03,
    width: 0.65,
    height: 1.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 413.47,
    y: 222.13,
    width: 0.65,
    height: 3.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 416.06,
    y: 222.13,
    width: 0.65,
    height: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M415.09,221.75c-.79,0-1.43-.64-1.43-1.43s.64-1.43,1.43-1.43,1.43.64,1.43,1.43-.64,1.43-1.43,1.43M415.09,219.53c-.43,0-.78.35-.78.78s.35.78.78.78.78-.35.78-.78-.35-.78-.78-.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 477.34,
    y: 60.43,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M493.94,77.03h-16.89v-16.89h16.89v16.89ZM477.63,76.44h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M483.55,74.53h-.65v-7.88h3.2c1.06,0,1.97.9,1.99,1.97,0,.55-.2,1.06-.58,1.45-.37.38-.88.59-1.41.59h-1.91v-.65h1.91c.36,0,.69-.14.95-.4.26-.26.4-.61.39-.98-.01-.71-.64-1.33-1.34-1.33h-2.55v7.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "483.18 62.07 481.22 64.02 482.14 64.02 483.18 62.99 484.23 64.02 485.15 64.02 483.18 62.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "488.83 62.07 487.79 63.11 486.75 62.07 485.83 62.07 487.79 64.02 489.75 62.07 488.83 62.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "490.69 75.1 480.3 75.1 480.3 64.68 490.68 64.68 490.68 73.77 490.03 73.77 490.03 65.32 480.95 65.32 480.95 74.45 490.69 74.45 490.69 75.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M333.23,445.78l-3.32,3.32.83.83,4.17-4.17-.41-.41c-2.3-2.3-6.04-2.3-8.34,0l.83.83c1.7-1.7,4.39-1.83,6.24-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M326.17,438.73c1.44,1.85,1.32,4.54-.39,6.24l.83.83c2.3-2.3,2.3-6.04,0-8.34l-.41-.41-4.17,4.17.83.83,3.32-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M342.62,455.17l-3.32,3.32.83.83,4.17-4.17-.41-.41c-2.3-2.3-6.04-2.3-8.34,0l.83.83c1.7-1.7,4.39-1.83,6.24-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M335.56,448.12c1.44,1.85,1.32,4.54-.39,6.24l.83.83c2.3-2.3,2.3-6.04,0-8.34l-.41-.41-4.17,4.17.83.83,3.32-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,285.63h-4.69v1.17h5.9v-.59c0-3.25-2.65-5.9-5.9-5.9v1.17c2.41,0,4.4,1.81,4.69,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,275.65c-.29,2.33-2.28,4.14-4.69,4.14v1.17c3.25,0,5.9-2.64,5.9-5.9v-.59h-5.9v1.17h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,298.91h-4.69v1.17h5.9v-.59c0-3.25-2.65-5.9-5.9-5.9v1.17c2.41,0,4.4,1.81,4.69,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,288.93c-.29,2.33-2.28,4.14-4.69,4.14v1.17c3.25,0,5.9-2.64,5.9-5.9v-.59h-5.9v1.17h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,149.34h-4.69v1.17h5.9v-.59c0-3.25-2.65-5.9-5.9-5.9v1.17c2.41,0,4.4,1.81,4.69,4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M11.83,139.36c-.29,2.33-2.28,4.14-4.69,4.14v1.17c3.25,0,5.9-2.64,5.9-5.9v-.59h-5.9v1.17h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M292.07,12.28v-4.69h-1.17v5.9h.59c3.25,0,5.9-2.64,5.9-5.9h-1.17c0,2.41-1.81,4.4-4.14,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M302.05,12.28c-2.33-.29-4.14-2.28-4.14-4.69h-1.17c0,3.25,2.64,5.9,5.9,5.9h.59v-5.9h-1.17v4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376.15,12.28v-4.69h-1.17v5.9h.59c3.25,0,5.9-2.64,5.9-5.9h-1.17c0,2.41-1.81,4.4-4.14,4.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M386.13,12.28c-2.33-.29-4.14-2.28-4.14-4.69h-1.17c0,3.25,2.64,5.9,5.9,5.9h.59v-5.9h-1.17v4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M505.68,38.63l2.06-4.21-1.05-.51-2.59,5.3.53.26c2.92,1.43,6.46.22,7.89-2.71l-1.05-.51c-1.06,2.16-3.56,3.16-5.78,2.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M514.65,43.02c-1.97-1.28-2.72-3.87-1.66-6.03l-1.05-.51c-1.43,2.92-.22,6.46,2.71,7.89l.53.26,2.59-5.3-1.05-.51-2.06,4.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 57.13,
    y: 119.18,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M73.73,135.78h-16.89v-16.89h16.89v16.89ZM57.43,135.2h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M70.87,133.85h-11.16c-.51,0-.93-.42-.93-.93v-11.16c0-.51.41-.93.93-.93h11.16c.51,0,.93.42.93.93v11.16c0,.51-.42.93-.93.93M59.71,121.48c-.15,0-.28.12-.28.28v11.16c0,.15.13.28.28.28h11.16c.15,0,.28-.12.28-.28v-11.16c0-.15-.13-.28-.28-.28h-11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M65.61,123.43v-.65h-.65v.65c-1.3.1-2.27.78-2.27,1.63v.47c0,.07,0,.13.02.2.05.28.25.54.57.74l1.69,1.05v3.07c-.97-.09-1.62-.55-1.62-.97v-.47h-.65v.47c0,.85.98,1.53,2.27,1.63v.65h.65v-3.97l1.35.84c.15.09.25.21.27.3,0,.03,0,.05,0,.08v.47c0,.32-.37.66-.97.85v.68c.96-.24,1.62-.82,1.62-1.52v-.47c0-.06,0-.13-.02-.2-.05-.29-.25-.54-.57-.74l-1.69-1.05v-3.72ZM64.96,126.75l-1.35-.84c-.15-.09-.25-.21-.27-.3,0-.03,0-.05,0-.08v-.47c0-.42.65-.89,1.62-.98v2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.26,123.54v.67c.6.19.98.53.98.85v.47h.65v-.47c0-.7-.66-1.29-1.62-1.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 492.11,
    y: 255.48,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M508.71,272.08h-16.89v-16.89h16.89v16.89ZM492.41,271.5h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M505.85,270.15h-11.16c-.51,0-.93-.42-.93-.93v-11.16c0-.51.41-.93.93-.93h11.16c.51,0,.93.42.93.93v11.16c0,.51-.42.93-.93.93M494.69,257.78c-.15,0-.28.12-.28.28v11.16c0,.15.13.28.28.28h11.16c.15,0,.28-.12.28-.28v-11.16c0-.15-.13-.28-.28-.28h-11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M500.59,259.73v-.65h-.65v.65c-1.3.1-2.27.78-2.27,1.63v.47c0,.07,0,.13.02.2.05.28.25.54.57.74l1.69,1.05v3.07c-.97-.09-1.62-.55-1.62-.98v-.47h-.65v.47c0,.85.98,1.53,2.27,1.63v.65h.65v-3.97l1.35.84c.15.1.25.21.27.3,0,.03,0,.05,0,.08v.47c0,.32-.37.66-.97.85v.68c.96-.24,1.62-.82,1.62-1.52v-.47c0-.06,0-.13-.02-.2-.05-.29-.25-.54-.57-.74l-1.69-1.05v-3.72ZM499.94,263.05l-1.35-.84c-.15-.09-.25-.21-.27-.3,0-.03,0-.05,0-.08v-.47c0-.42.65-.89,1.62-.98v2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M501.24,259.84v.67c.6.19.98.53.98.85v.47h.65v-.47c0-.7-.66-1.29-1.62-1.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 331.43,
    y: 114.37,
    width: 16.31,
    height: 16.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M348.03,130.97h-16.89v-16.89h16.89v16.89ZM331.72,130.39h15.72v-15.72h-15.72v15.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 339.26,
    y: 121.23,
    width: 0.65,
    height: 5.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M339.58,117.99c-.71,0-1.29.58-1.29,1.29s.58,1.29,1.29,1.29,1.29-.58,1.29-1.29-.58-1.29-1.29-1.29M339.58,119.92c-.35,0-.64-.29-.64-.64s.29-.64.64-.64.64.29.64.64-.29.64-.64.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M345.16,116.02h-11.17c-.51,0-.93.42-.93.93v11.17c0,.51.42.93.93.93h11.17c.51,0,.93-.42.93-.93v-11.17c0-.51-.42-.93-.93-.93M345.44,128.12c0,.15-.12.28-.28.28h-11.17c-.15,0-.28-.13-.28-.28v-11.17c0-.15.12-.28.28-.28h11.17c.15,0,.28.12.28.28v11.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M605.43,167.23h4.69v-1.17h-5.9v.59c0,3.25,2.64,5.9,5.9,5.9v-1.17c-2.41,0-4.4-1.81-4.69-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M605.43,177.21c.29-2.33,2.28-4.14,4.69-4.14v-1.17c-3.25,0-5.9,2.64-5.9,5.9v.59h5.9v-1.17h-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M605.43,153.95h4.69v-1.17h-5.9v.59c0,3.25,2.64,5.9,5.9,5.9v-1.17c-2.41,0-4.4-1.81-4.69-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M605.43,163.93c.29-2.33,2.28-4.14,4.69-4.14v-1.17c-3.25,0-5.9,2.64-5.9,5.9v.59h5.9v-1.17h-4.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 609.9,
    y: 139.83,
    width: 1.19,
    height: 52.79
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(110.87 122.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11&amp;12"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(21.02 71.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(34.18 212.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(172.89 218.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(349.46 229.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(172.89 173.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(172.89 265.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(41.53 340.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(118.66 340.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(204.28 340.13)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(221.56 172.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "26"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(305.62 272.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(234.01 237.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "29"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(383.49 264.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(419.24 300.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(465.57 232.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16E"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(440.16 206.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16D"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(408.46 179.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16C"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(491.99 174.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16A"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(440.41 123.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(234.01 126.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(558.71 100.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(570.01 244.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(465.34 366.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(532.52 174.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16B"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(343.48 307.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(294.98 375.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(379.33 343.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(299.08 185.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(264.56 172.19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 334.86) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u79AE\u8CD3\u90E8"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 345.74) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Concie"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 27.51,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 30.77,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.5,
    y: 0
  }, "e"))), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 612.18,
    y: 327.48,
    width: 18.06,
    height: 18.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M612.5,345.21h17.41v-17.41h-17.41v17.41ZM630.56,345.86h-18.71v-18.71h18.71v18.71Z"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 620.85,
    y: 335.08,
    width: 0.72,
    height: 6.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M621.21,333.62c-.39,0-.71-.32-.71-.71s.32-.71.71-.71.71.32.71.71-.32.71-.71.71M621.21,331.48c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M627.7,342.7c0,.17-.14.31-.31.31h-12.37c-.17,0-.31-.14-.31-.31v-12.37c0-.17.14-.31.31-.31h12.37c.17,0,.31.14.31.31v12.37ZM627.39,329.3h-12.37c-.57,0-1.03.46-1.03,1.03v12.37c0,.57.46,1.03,1.03,1.03h12.37c.57,0,1.03-.46,1.03-1.03v-12.37c0-.57-.46-1.03-1.03-1.03"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 402.29) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5347\u964D\u6A5F"))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 413.18) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 612.18,
    y: 394.77,
    width: 18.06,
    height: 18.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M612.5,412.51h17.41v-17.41h-17.41v17.41ZM630.56,413.16h-18.71v-18.71h18.71v18.71Z"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "618.66 396.59 616.48 398.76 617.5 398.76 618.66 397.61 619.81 398.76 620.83 398.76 618.66 396.59"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "624.91 396.6 623.76 397.74 622.6 396.6 621.58 396.6 623.76 398.76 625.93 396.6 624.91 396.6"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 617.3,
    y: 404.21,
    width: 0.65,
    height: 3.07
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 617.94,
    y: 407.28,
    width: 0.65,
    height: 3.07
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 619.9,
    y: 404.21,
    width: 0.65,
    height: 3.07
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 619.26,
    y: 407.28,
    width: 0.65,
    height: 3.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M618.93,401.91c-.35,0-.64.29-.64.64s.29.64.64.64.64-.29.64-.64-.29-.64-.64-.64M618.93,403.84c-.71,0-1.29-.58-1.29-1.29s.58-1.29,1.29-1.29,1.29.58,1.29,1.29-.58,1.29-1.29,1.29"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 621.85,
    y: 404.21,
    width: 0.65,
    height: 3.07
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 622.49,
    y: 407.28,
    width: 0.65,
    height: 3.07
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 624.45,
    y: 404.21,
    width: 0.65,
    height: 3.07
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 623.8,
    y: 407.28,
    width: 0.65,
    height: 3.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M623.48,401.91c-.35,0-.64.29-.64.64s.29.64.64.64.64-.29.64-.64-.29-.64-.64-.64M623.48,403.84c-.71,0-1.29-.58-1.29-1.29s.58-1.29,1.29-1.29,1.29.58,1.29,1.29-.58,1.29-1.29,1.29"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "626.97 411.02 615.46 411.02 615.46 399.48 626.96 399.48 626.96 409.55 626.24 409.55 626.24 400.2 616.18 400.2 616.18 410.3 626.97 410.3 626.97 411.02"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 368.62) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u6276\u624B\u96FB\u68AF"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 379.5) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Es"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 9.1,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.4,
    y: 0
  }, "al"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 20.71,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 25.45,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 28.57,
    y: 0
  }, "or"))), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 612.18,
    y: 361.1,
    width: 18.06,
    height: 18.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M612.5,378.84h17.41v-17.41h-17.41v17.41ZM630.56,379.48h-18.71v-18.71h18.71v18.71Z"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "619.4 377.35 613.99 377.35 613.99 373.74 618.09 373.74 624.09 369.42 628.42 369.42 628.42 371.57 627.7 371.57 627.7 370.14 624.32 370.14 618.32 374.46 614.71 374.46 614.71 376.63 619.17 376.63 625.13 372.31 628.41 372.31 628.41 373.03 625.36 373.03 619.4 377.35"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 618.33,
    y: 370.85,
    width: 0.72,
    height: 2.9
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 619.76,
    y: 370.85,
    width: 0.72,
    height: 1.91
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 617.62,
    y: 366.53,
    width: 0.72,
    height: 4.32
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 620.49,
    y: 366.53,
    width: 0.72,
    height: 4.32
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M619.41,363.65c-.48,0-.87.39-.87.87s.39.87.87.87.87-.39.87-.87-.39-.87-.87-.87M619.41,366.1c-.88,0-1.59-.71-1.59-1.59s.71-1.59,1.59-1.59,1.59.71,1.59,1.59-.71,1.59-1.59,1.59"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 469.52) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u6536\u9280\u8655"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 480.41) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cashier"))), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 612.18,
    y: 462,
    width: 18.06,
    height: 18.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M612.5,479.74h17.41v-17.41h-17.41v17.41ZM630.56,480.39h-18.71v-18.71h18.71v18.71Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M615.03,464.55c-.17,0-.31.14-.31.31v12.36c0,.17.14.31.31.31h12.36c.17,0,.31-.14.31-.31v-12.36c0-.17-.14-.31-.31-.31h-12.36ZM627.39,478.24h-12.36c-.57,0-1.03-.46-1.03-1.03v-12.36c0-.57.46-1.03,1.03-1.03h12.36c.57,0,1.03.46,1.03,1.03v12.36c0,.57-.46,1.03-1.03,1.03"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M620.85,470.39l-1.49-.93c-.17-.1-.28-.23-.3-.34,0-.03,0-.06,0-.09v-.52c0-.47.72-.98,1.8-1.08v2.95ZM621.57,466.71v-.72h-.72v.72c-1.44.11-2.52.86-2.52,1.8v.52c0,.07,0,.15.02.22.06.32.27.6.63.82l1.87,1.16v3.4c-1.08-.1-1.8-.61-1.8-1.08v-.52h-.72v.52c0,.94,1.08,1.69,2.52,1.8v.72h.72v-4.4l1.49.93c.17.1.28.23.3.33,0,.03,0,.06,0,.09v.52c0,.35-.41.73-1.08.94v.75c1.06-.26,1.8-.91,1.8-1.69v-.52c0-.07,0-.15-.02-.22-.06-.32-.27-.6-.63-.82l-1.87-1.16v-4.12Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M622.29,466.83v.75c.67.21,1.08.59,1.08.94v.52h.72v-.52c0-.78-.73-1.42-1.8-1.69"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 612.18,
    y: 428.39,
    width: 18.06,
    height: 18.06
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M612.5,446.13h17.41v-17.41h-17.41v17.41ZM630.56,446.77h-18.71v-18.71h18.71v18.71Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M619.06,444h-.72v-8.73h3.54c1.17,0,2.18,1,2.2,2.18.01.61-.22,1.18-.64,1.61-.42.42-.97.66-1.56.66h-2.11v-.72h2.11c.4,0,.77-.16,1.05-.44.29-.29.44-.68.43-1.09-.01-.79-.7-1.48-1.48-1.48h-2.82v8.01Z"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "618.65 430.2 616.48 432.37 617.5 432.37 618.65 431.22 619.81 432.37 620.83 432.37 618.65 430.2"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "624.91 430.21 623.75 431.35 622.6 430.21 621.58 430.21 623.75 432.37 625.93 430.21 624.91 430.21"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "626.96 444.64 615.45 444.64 615.45 433.09 626.95 433.09 626.95 443.16 626.23 443.16 626.23 433.81 616.17 433.81 616.17 443.91 626.96 443.91 626.96 444.64"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 435.97) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u505C\u8ECA\u5834\u5347\u964D\u6A5F"))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(639.34 446.85) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Car "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 15.63,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.67,
    y: 0
  }, "ark Lift"))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(318.86 70.04) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(323.66 69.18) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(325.55 70.04) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(323.6 73.73) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "|"))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(317.28 80.38) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(325.24 79.52) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(327.13 80.38) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(316.99 92.89) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B1"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(325.53 92.02) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(327.41 92.89) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(323.6 96.58) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "|"))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(317.28 103.22) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(325.24 102.36) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(327.13 103.22) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(318.86 47.16) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(323.66 46.3) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(325.55 47.16) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(323.6 50.85) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "|"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(317.28 57.5) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(325.24 56.64) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(327.13 57.5) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(494.9 65.78) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B4"))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(503.43 64.92) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(505.32 65.78) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(501.5 69.47) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "|"))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(496.77 76.12) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(501.56 75.26) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(503.45 76.12) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(318.86 24.21) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(323.66 23.34) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(325.55 24.2) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(323.6 27.9) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "|"))), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(317.28 34.54) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(325.24 33.68) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(327.13 34.54) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(384.92 30.67) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(389.71 29.81) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(391.6 30.67) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(383.33 38.93) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(391.3 38.07) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(393.18 38.93) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(375.38 47.2) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12"))), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(383.35 46.33) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(385.24 47.2) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F-"))), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(391.28 47.2) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16"))), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(399.24 46.33) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(401.13 47.2) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(375.38 55.46) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18"))), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(383.35 54.6) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(385.24 55.46) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F-"))), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(391.28 55.46) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20"))), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(399.24 54.6) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(401.13 55.46) scale(1 1.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.80e89706ebb97fb9ae24c1e4a1dc77b7.svg";
export { ForwardRef as ReactComponent };